import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { FilterTypeComponents } from '@/app/common/filters/types/filterTypeDefinition.ts';
import { FilterMultiSelect } from '@/app/common/filters/types/multiSelect/FilterMultiSelect.tsx';
import { FilterMultiSelectBadge } from '@/app/common/filters/types/multiSelect/FilterMultiSelectBadge.tsx';
import { FilterRadio } from '@/app/common/filters/types/radio/FilterRadio.tsx';
import { FilterRadioBadge } from '@/app/common/filters/types/radio/FilterRadioBadge.tsx';
import { FilterRange } from '@/app/common/filters/types/range/FilterRange.tsx';
import { FilterRangeBadge } from '@/app/common/filters/types/range/FilterRangeBadge.tsx';
import { FilterSearch } from '@/app/common/filters/types/search/FilterSearch.tsx';
import { FilterSearchBadge } from '@/app/common/filters/types/search/FilterSearchBadge.tsx';
import { FilterSearchDynamicBadge } from '@/app/common/filters/types/searchDynamic/FilterSearchDynamicBadge.tsx';
import { FilterSwitch } from '@/app/common/filters/types/switch/FilterSwitch.tsx';
import { FilterSwitchBadge } from '@/app/common/filters/types/switch/FilterSwitchBadge.tsx';

export const FILTER_TYPE_COMPONENTS: Record<FILTER_TYPE, FilterTypeComponents> = {
  [FILTER_TYPE.SWITCH]: { Main: FilterSwitch, Badge: FilterSwitchBadge },
  [FILTER_TYPE.MULTI_SELECT]: { Main: FilterMultiSelect, Badge: FilterMultiSelectBadge },
  [FILTER_TYPE.RADIO]: { Main: FilterRadio, Badge: FilterRadioBadge },
  [FILTER_TYPE.RANGE]: { Main: FilterRange, Badge: FilterRangeBadge },
  [FILTER_TYPE.SEARCH]: { Main: FilterSearch, Badge: FilterSearchBadge },
  [FILTER_TYPE.SEARCH_DYNAMIC]: { Main: () => null, Badge: FilterSearchDynamicBadge },
};

export const filterComponentsOf = (filter: Filter): FilterTypeComponents => FILTER_TYPE_COMPONENTS[filter.type];
